import { create } from 'zustand';

interface ModalState {
  isOpen: boolean;
  isOpenOrkestadoc: boolean;
  title: string;
  imageUrl: string;
  subtitle: string;
  content: string;
  openModal: (title: string, imageUrl: string, subtitle: string, content: string) => void;
  closeModal: () => void;
  openModalOrkestadoc: () => void;
  closeModalOrkestadoc: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  isOpen: false,
  isOpenOrkestadoc: false,
  title: '',
  imageUrl: '',
  subtitle: '',
  content: '',
  openModal: (title, imageUrl, subtitle, content) =>
    set({ isOpen: true, title, imageUrl, subtitle, content }),
  closeModal: () => set({ isOpen: false, title: '', imageUrl: '', subtitle: '', content: '' }),
  openModalOrkestadoc: () =>
    set({ isOpenOrkestadoc: true }),
  closeModalOrkestadoc: () => set({ isOpenOrkestadoc: false}),
}));
